import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Accordion, AccordionHeading } from '@yuno/sdk-web-core/dist/ui/primitives/accordion'

export const OrderContainer = styled.article`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  padding: 24px 16px 16px 16px;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      padding: 80px;
      min-height: 0;
    }
  `}
`

export const OrderHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  width: 100%;
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  flex: 1 0 0;
`

export const MerchantLogo = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
`

export const Heading = styled.h1`
  ${({ theme }) => css({ ...theme.typographys.m.bold })}
  color: ${({ theme }) => theme.colors.neutrals.b};
  ${({ theme }) => css`
    ${theme.breakpoints.desktop} {
      ${css({ ...theme.typographys.xl.bold })}
    }
  `}
`

export const Instructions = styled.p`
  ${({ theme }) => css({ ...theme.typographys.tiny.regular })}
  color: ${({ theme }) => theme.colors.grey[5]};
`


export const OrderMobileAccordion = styled(Accordion)`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: none;
  box-shadow: none;

  > * {
    border: none;
    box-shadow: none;
  }

  .sdk-payments-accordion__heading {
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
  }

  .sdk-payments-accordion__heading-title {
    padding: 8px 0;
    border: none !important;
    background: transparent !important;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #6C6F75;
  }

  .close .sdk-payments-accordion__heading-title::after {
    right: 0;
  }

  .open .sdk-payments-accordion__heading-title::after {
    right: 2px;
  }

  .sdk-payments-accordion__content {
    padding-top: 24px;
  }
`

export const OrderScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  width: 100%;
`

export const OrderDetailsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const OrderDetailContentContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.neutrals.w};
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const OrderDetailContentLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const OrderDetailContentName = styled.div`
  ${({ theme }) => css({ ...theme.typographys.small.regular })}
`

export const OrderDetailContentPrice = styled.div`
  ${({ theme }) => css({ ...theme.typographys.small.regular })}
  flex-shrink: 0;
`

export const OrderDetailContentQuantity = styled.div`
  ${({ theme }) => css({ ...theme.typographys.small.regular })}
  color: ${({ theme }) => theme.colors.grey[4]};
`

export const OrderTotalWrapper = styled.div`
  width: 100%;
  padding: 48px 0 24px 0;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      padding: 48px 0 48px 0;
    }
  `}
`

const OrderTotalItem = styled.div`
  display: flex;
  justify-content: space-between;

  span {
    flex-grow: 0;
  }
`

export const OrderTotalSubtotal = styled(OrderTotalItem)`
  span {
    ${({ theme }) => css({ ...theme.typographys.small.regular })}
  }
`

export const OrderTotalDue = styled(OrderTotalSubtotal)`
  flex-direction: column;
  align-items: flex-start;

  span {
    text-align: left;
  }

  span:last-child {
    ${({ theme }) => css({ ...theme.typographys.m.bold })}
    font-size: 32px;
    line-height: 40px;
    color: ${({ theme }) => theme.colors.neutrals.b};
    margin-top: 8px;
  }

  [dir="rtl"] & span {
    text-align: right;
  }
`

export const OrderDetailPurchaseItem = styled.div`
  background-color: ${({ theme }) => theme.colors.neutrals.w};
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 8px;
  padding: 16px;
`

export const OrderDetailPurchaseTitle = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 4px;
  padding: 8px 7px;
  display: flex;
  align-items: center;

  span:first-of-type {
    flex-grow: 1;
  }
`

export const OrderDetailPurchaseDetails = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 8px;
`

export const OrderDetailPurchaseDepartureRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  span:first-child {
    flex: 1;
    color: ${({ theme }) => theme.colors.neutrals.b};
  }

  span:last-child {
    flex: 1;
    text-align: right;
    color: ${({ theme }) => theme.colors.neutrals.b};
  }
`

export const OrderDetailPurchaseDetailsArrival = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;
  width: 137px;
  margin-left: auto;

  [dir="rtl"] & {
    text-align: left;
    margin-left: 0;
    margin-right: auto;
  }

  span {
    display: block;
    width: 137px;
    font-size: 10px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.neutrals.b};
  }
`

export const OrderDetailPurchaseTitleSeparator = styled.div`
  height: 16px;
  border-right: 1px solid ${({ theme }) => theme.colors.grey[4]};
  padding-left: 10px;
  margin-right: 10px;

  [dir="rtl"] & {
    border-right: none;
    border-left: 1px solid ${({ theme }) => theme.colors.grey[4]};
    padding-left: 0;
    padding-right: 10px;
    margin-right: 0;
    margin-left: 10px;
  }
`

export const OrderDetailPurchaseTitleSeparatorH = styled.div`
  height: 1px;
  width: 100px;
  background-color: ${({ theme }) => theme.colors.grey[2]};
  margin: 0 12px;
  flex-shrink: 0;
`

export const OrderDetailPurchaseSpanRegular = styled.span`
  ${({ theme }) => css(theme.typographys.tiny.regular)};
  color: ${({ theme }) => theme.colors.grey[5]};

  [dir="rtl"] &.rtl-left {
    text-align: left;
  }
`

export const OrderDetailPurchaseSpanBold = styled.span`
  ${({ theme }) => css(theme.typographys.tiny.bold)};
  color: ${({ theme }) => theme.colors.grey[5]};
`

export const AccordionHeadingPurchase = styled(AccordionHeading)`
  button {
    border: none;
    background-color: transparent;
    padding: 8px 0;
    ${({ theme }) => css(theme.typographys.tiny.bold)};
    color: ${({ theme }) => theme.colors.grey[5]};

    &::after {
      right: 0;
    }

    &[aria-expanded='true'] {
      &::after {
        right: 2px;
      }
    }

    [dir="rtl"] & {
      &::after {
        left: 0;
        right: initial !important;
      }

      &[aria-expanded='true'] {
        &::after {
          left: 2px;
        }
      }
    }
  }
`

export const LeftPanelFooter = styled.div`
  display: none;
  flex-direction: column;
  gap: 16px;
  margin-top: auto;
  padding-top: 24px;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: flex;
    }
  `}
`

export const LanguageSelectorTop = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 32px;
  ${({ theme }) => `
    ${theme.breakpoints.desktop} {
      display: none;
    }
  `}
`
